module.exports = __webpack_public_path__ + "img/download.8fba04c2.png";